import styled from 'styled-components';
import { colors } from '@keen.io/colors';
export var Container = styled.div.withConfig({
  displayName: "Timeframestyles__Container",
  componentId: "keen-query-creator__sc-bolxka-0"
})(["&&&{position:relative;}"]);
export var ErrorContainer = styled.div.withConfig({
  displayName: "Timeframestyles__ErrorContainer",
  componentId: "keen-query-creator__sc-bolxka-1"
})(["&&&{padding:15px 10px;}"]);
export var SettingsContainer = styled.div.withConfig({
  displayName: "Timeframestyles__SettingsContainer",
  componentId: "keen-query-creator__sc-bolxka-2"
})(["&&&{padding:15px 10px;border-top:solid 1px ", ";border-bottom:solid 1px ", ";}"], colors.white[300], colors.white[300]);